import { App } from '@capacitor/app';

export function registerDeepLinks(history) {
    App.addListener('appUrlOpen', ({ url }) => {
        try {
            const u = new URL(url);
            const p = u.pathname; // e.g. /dashboard/home/123  or /api-ca-world/common/shareAppContentData/news/123

            // If someone opens the "share" URL directly:
            if(p){
                if (p.startsWith('/api-ca-world/common/shareAppContentData/news/')
                || p.startsWith('/dashboard/home/')) {
                    const id = p.split('/').pop();
                    return history.replace(`/dashboard/home/${id}`);
                }else if (p.startsWith('/api-ca-world/common/shareAppContentData/job/')
                || p.startsWith('/dashboard/job-portal/')) {
                    const id = p.split('/').pop();
                    return history.replace(`/dashboard/job-portal/${id}`);
                }else if (p.startsWith('/api-ca-world/common/shareAppContentData/event/')
                || p.startsWith('/dashboard/events/')) {
                    const id = p.split('/').pop();
                    return history.replace(`/dashboard/events/${id}`);
                }else if (p) {
                    history.replace(p);
                }
            }
        } catch (e) {
            console.log('Deep link parse error', e);
        }
    });
}
